import React from "react"
import { concatClassNames } from "helpers/jsxHelpers"

interface DropdownSpanProps {
	title: string
	onClick?: () => void
	disabled: boolean
	children: React.ReactNode
}

const DropdownSpan: React.FC<DropdownSpanProps> = ({
	title,
	onClick = () => undefined,
	disabled,
	children,
}) => {
	return (
		<span
			title={title}
			className={concatClassNames(["dropdown-span", disabled && "disabled"])}
			onClick={onClick}
		>
			{children}
		</span>
	)
}

export default DropdownSpan
